import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bo/memberships/')({
  component: () => <Navigate replace search to="/bo/organizations" />,
})
